import React from 'react';
import { useLang, tx } from '../../i18n/LanguageContext';
import { isHtml, safeHtml } from '../../lib/richText';
import { isVideoUrl } from '../articles/articleUtils';

const abs = (u) => (u && u.startsWith('/api/') ? `${process.env.REACT_APP_BACKEND_URL}${u}` : u);
const noDl = { controls: true, controlsList: 'nodownload noplaybackrate noremoteplayback', disablePictureInPicture: true, onContextMenu: (e) => e.preventDefault(), preload: 'metadata' };

const Media = ({ url, caption }) => (
  <figure className="m-0">
    <div className="rounded-xl overflow-hidden border border-slate-200 bg-black">
      {isVideoUrl(url) ? <video src={abs(url)} {...noDl} className="w-full aspect-video" /> : <img src={abs(url)} alt={caption || ''} loading="lazy" className="w-full max-h-[520px] object-cover" />}
    </div>
    {caption && <figcaption className="text-slate-500 text-sm mt-2 px-1">{caption}</figcaption>}
  </figure>
);

const Body = ({ text, className = '' }) => (isHtml(text)
  ? <div className={`rich-content text-slate-700 text-[15px] leading-loose ${className}`} dangerouslySetInnerHTML={{ __html: safeHtml(text) }} />
  : <p className={`text-slate-700 text-[15px] leading-loose whitespace-pre-line m-0 ${className}`}>{text}</p>);

// Renders a linked library article inline inside the course learn page.
export const LessonArticle = ({ article }) => {
  const { lang } = useLang();
  const pick = (ar, en) => (lang === 'ar' ? (ar || en) : (en || ar));
  const content = pick(article.contentAr, article.contentEn);
  const sections = article.sections || [];
  return (
    <article data-testid="learn-article-inline" className="sm:rounded-xl border-y sm:border border-slate-200 bg-white px-5 py-6 sm:p-8 space-y-6">
      {article.cover && <Media url={article.cover} />}
      {content && <Body text={content} />}
      {sections.map((s) => {
        if (s.type === 'text') { const t = pick(s.textAr, s.textEn); return t ? <Body key={s.id} text={t} /> : null; }
        return s.url ? <Media key={s.id} url={s.url} caption={pick(s.captionAr, s.captionEn)} /> : null;
      })}
      {!content && !sections.length && !article.cover && <p className="text-slate-400 text-sm text-center py-6">{tx(lang, 'لا يوجد محتوى لهذا المقال بعد', 'This article has no content yet')}</p>}
    </article>
  );
};
